import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListTypeEntrepriseComponent } from './list-typeEntreprise/list-typeEntreprise.component';
import { FilterTypeEntrepriseByNamePipe } from 'src/app/shared/pipes/filter-typeEntreprise-by-name/filter-typeEntreprise-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { TypeEntrepriseModalDetailComponent } from './modal/typeEntreprise-modal-detail/typeEntreprise-modal-detail.component';
import { TypeEntrepriseModalAjoutComponent } from './modal/typeEntreprise-modal-ajout/typeEntreprise-modal-ajout.component';

@NgModule({
	declarations: [
		ListTypeEntrepriseComponent,
		TypeEntrepriseModalDetailComponent,
		TypeEntrepriseModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTypeEntrepriseByNamePipe]
})

export class TypeEntrepriseModule {}
